// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"e0a2439f","787":"a44f2ff0","805":"c156ef80"}[chunkId] + ".chunk.js";
};